<template>
	<svg
		width="25"
		height="26"
		viewBox="0 0 25 26"
		fill="none"
		:class="iconColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.07852 17.6627C6.81542 17.6101 5.63127 17.5048 4.52606 17.2943V20.5836C4.52606 21.1889 5.02604 21.6888 5.63127 21.6888H14.1309C14.7361 21.6888 15.2361 21.1889 15.2361 20.5836V17.2943C14.1572 17.4785 12.973 17.5838 11.6836 17.6364C11.6573 18.3469 11.0784 18.9258 10.3416 18.9258H9.39424C8.68375 18.9521 8.10483 18.3732 8.07852 17.6627Z"
			fill="currentColor"
		/>
		<path
			d="M10.8942 10.663H8.86802C7.99964 10.663 7.28915 11.3735 7.28915 12.2419V13.0576H4.8419C4.23667 13.0576 3.73669 13.5576 3.73669 14.1629V15.8733C3.73669 16.0312 3.84195 16.1628 3.99984 16.1891C5.05242 16.3996 6.42077 16.5575 8.07859 16.6364C8.07859 15.8996 8.68382 15.2944 9.42062 15.2944H10.3679C11.1048 15.2944 11.71 15.8996 11.71 16.6364C13.3678 16.5575 14.7098 16.3996 15.7887 16.1628C15.9466 16.1364 16.0519 16.0049 16.0519 15.847V14.1365C16.0519 13.5313 15.5519 13.0313 14.9467 13.0313H12.4994V12.2156C12.4731 11.3735 11.7626 10.663 10.8942 10.663ZM11.1311 13.0576H8.63119V12.2419C8.63119 12.1103 8.73645 12.0051 8.86802 12.0051H10.8942C11.0258 12.0051 11.1311 12.1103 11.1311 12.2419V13.0576Z"
			fill="currentColor"
		/>
		<path
			d="M10.3679 18.0049C10.5784 18.0049 10.7363 17.847 10.7363 17.6365V16.6366C10.7363 16.426 10.5784 16.2682 10.3679 16.2682H9.36791C9.1574 16.2682 8.99951 16.426 8.99951 16.6366V17.6102C8.99951 17.8207 9.1574 17.9786 9.36791 17.9786H10.3679V18.0049Z"
			fill="currentColor"
		/>
		<path
			d="M18.3938 22.1362C18.3938 23.1361 17.5781 23.9519 16.5781 23.9519H3.18405C2.1841 23.9519 1.36835 23.1361 1.36835 22.1362V10.242C1.36835 9.24206 2.1841 8.42631 3.18405 8.42631H11.2889C11.131 7.97896 10.9995 7.53161 10.9205 7.05795H3.18405C1.42098 7.05795 0 8.47894 0 10.242V22.1098C0 23.8992 1.42098 25.3202 3.18405 25.3202H16.5781C18.3412 25.3202 19.7622 23.8992 19.7622 22.1362V12.4261C19.3148 12.584 18.8675 12.6629 18.3938 12.7156V22.1362Z"
			fill="currentColor"
		/>
		<path
			d="M24.6567 11.5051L22.0516 9.11049C22.6568 8.2158 23.0252 7.16322 23.0252 6.00538C23.0252 3.00553 20.578 0.584595 17.6044 0.584595C14.6309 0.584595 12.1837 3.00553 12.1837 6.00538C12.1837 8.97892 14.6046 11.4262 17.6044 11.4262C18.7623 11.4262 19.8149 11.0578 20.7095 10.4525L23.1042 13.0577C23.1305 13.084 23.1568 13.1103 23.1568 13.1103C23.6041 13.5313 24.2883 13.4787 24.7094 13.0577C25.1304 12.584 25.0778 11.8998 24.6567 11.5051ZM17.6044 9.95255C15.4203 9.95255 13.6573 8.18948 13.6573 6.00538C13.6573 3.82128 15.4203 2.05821 17.6044 2.05821C19.7885 2.05821 21.5516 3.82128 21.5516 6.00538C21.5516 8.18948 19.7885 9.95255 17.6044 9.95255Z"
			fill="currentColor"
		/>
		<path
			d="M17.6044 3.29514C16.1044 3.29514 14.894 4.5056 14.894 6.00553C14.894 6.40025 15.2098 6.74233 15.6308 6.74233C16.0255 6.74233 16.3676 6.42656 16.3676 6.00553C16.3676 5.32135 16.9202 4.76875 17.6044 4.76875C17.9991 4.76875 18.3412 4.45297 18.3412 4.03194C18.3412 3.61091 17.9991 3.29514 17.6044 3.29514Z"
			fill="currentColor"
		/>
	</svg>
</template>
<script setup>
const props = defineProps({
	iconColor:{
		type:String,
		default:'#2A8176'
	}
}
);
</script>
